import http from '../utils/fetch';
export default {
    login(base64LoginInfo) {
        return http({
            url: 'api/website/login',
            method: 'post',
            params: {base64LoginInfo}
        });
    },
    logina(ucode,password,xitongcode) {
        return http({
            url: 'api/website/swylSaleplate',
            method: 'post',
            params: {ucode,password,xitongcode}
        });
    },
    loginb(flag,account) {
        return http({
            url: 'api/website/twologin',
            method: 'post',
            params: {flag,account}
        });
    },
    getphonecode(phone) {
        return http({
            url: 'api/website/getPhoneMessage',
            method: 'post',
            params: {phone}
        });
    },

    getIPAndUrl() {
        return http({
            url: 'api/website/getIPAndUrl',
            method: 'post'
        });
    }
    ,
    getIPAndUrlAim() {
        return http({
            url: 'api/website/getIPAndUrlAim',
            method: 'post'
        });
    },
    getUrlByLq(urlLq,url) {
        return http({
            url: 'api/website/getUrlByLq',
            method: 'post',
            params: {urlLq,url}
        });
    },
    idmLoginCheck(param) {
        return http({
            url: 'api/website/idmLoginCheck',
            method: 'post',
            params: param
        });
    },

    getCodeImg() {
        return http({
            url: 'api/website/captchaImage',
            method: 'get'
        });
    },

    getSsoLogin(query,query1){
        return http({
            url: '/api/website/ssoLogin?code='+query+"&state="+query1,
            method: 'post',
        });
    },

    getSsoLoginByLq(token,state,code){
        return http({
            url: '/api/website/ssoLoginByToken',
            method: 'post',
            params: {token,state,code}
        });
    },

    getLogOutUrl() {
        return http({
            url: 'api/website/getLogOutUrl',
            method: 'post'
        });
    },
    getLogCvp(query,query1){
        return http({
            url: 'api/website/getCvpeUrl?pageCode='+query+"&billCode="+query1,
            method: 'post'
        });
    },
    //ihaier待办连接单点登录接口
    getIhaierTaskUrlAim(taskUrl) {
        return http({
            url: 'api/website/getIhaierTaskUrlAim='+taskUrl,
            method: 'post'
        });
    },
    getItPt(userid) {
        return http({
            url: '/api/swyl/v1/basic/bscUserInfo/getItPt?userId='+userid,
            method: 'post'
        });
    },

    //测试获取合同pdf
    taskTest() {
        return http({
            responseType: 'arraybuffer',
            url: '/api/swyl/v1/demo/bscPartnerHighSeas/taskTest',
            method: 'post'
        });
    },
}
